import { makeMultiSorter } from 'components/table';
import { PreparedWorkload } from 'features/workload-optimization';

export const DiffSorter = makeMultiSorter({
  sortBy: [
    {
      name: 'CPU',
      accessor: (d: PreparedWorkload) => Math.abs(d.cpu.diff ?? 0),
      testId: 'cpu-diff',
    },
    {
      name: 'Memory',
      accessor: (d: PreparedWorkload) => Math.abs(d.memory.diff ?? 0),
      testId: 'memory-diff',
    },
  ],
});

export const CurrentDiffSorter = makeMultiSorter({
  sortBy: [
    {
      name: 'CPU',
      accessor: (d: PreparedWorkload) => Math.abs(d.cpu.currentDiff ?? 0),
      testId: 'cpu-current-diff',
    },
    {
      name: 'Memory',
      accessor: (d: PreparedWorkload) => Math.abs(d.memory.currentDiff ?? 0),
      testId: 'memory-current-diff',
    },
  ],
});

export const RequestedSorter = makeMultiSorter({
  sortBy: [
    {
      name: 'CPU',
      accessor: (d: PreparedWorkload) => d.cpu.requested ?? 0,
      testId: 'cpu-requested',
    },
    {
      name: 'Memory',
      accessor: (d: PreparedWorkload) => d.memory.requested ?? 0,
      testId: 'memory-requested',
    },
  ],
});

export const OriginalRequestsSorter = makeMultiSorter({
  sortBy: [
    {
      name: 'CPU',
      accessor: (d: PreparedWorkload) => d.cpu.originalRequests ?? 0,
      testId: 'cpu-originalRequests',
    },
    {
      name: 'Memory',
      accessor: (d: PreparedWorkload) => d.memory.originalRequests ?? 0,
      testId: 'memory-originalRequests',
    },
  ],
});
